// This is just the visual search box - very simple!
import React from 'react';
import { Input } from 'antd';

const { Search } = Input;

export class SearchInput extends React.Component {
  render() {
    const {
      placeholder,
      value,
      onChange,
      onSearch,
      onClear,
      style,
      ...rest
    } = this.props;

    return (
      <Search
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onSearch={onSearch}
        onClear={onClear}
        allowClear
        enterButton
        style={style || { width: "200px" }}
        {...rest}
      />
    );
  }
}

